import GET_ABOUT_PAGE_DATA from './getAboutPageData.gql';
import GET_ARTICLE_DATA from './getArticleData.gql';
import GET_COLOR_DATA from './getColorData.gql';
import GET_CONTACT_PAGE_DATA from './getContactPageData.gql';
import GET_COUNTRY from './getCountry.gql';
import GET_COUNTRY_NAMES from './getCountryNames.gql';
import GET_DESIGNATED_LEAGUES_PAGE_DATA from './getDesignatedLeaguesPageData.gql';
import GET_EVENTS_CSV_LINK from './getEventsCsvLink.gql';
import GET_EVENTS_PAGE_DATA from './getEventsPageQuery.gql';
import GET_FINALS_PAGE_DATA from './getFinalsPageData.gql';
import GET_GALLERY_PAGE_DATA from './getGalleryPageData.gql';
import GET_GLOBAL_REGISTRATION_PAGE_DATA from './getGlobalRegistrationPageData.gql';
import GET_HISTORY_PAGE_DATA from './getHistoryPageData.gql';
import GET_HOME_PAGE_DATA from './getHomePageData.gql';
import GET_PARTNERS_PAGE_DATA from './getPartnersPageData.gql';
import GET_REGISTRATION_PAGE_DATA from './getRegistrationPageData.gql';
import GET_RULES_PAGE_DATA from './getRulesPageData.gql';
import GET_SCORES_PAGE_DATA from './getScoresPageData.gql';

export {
  GET_COUNTRY,
  GET_HOME_PAGE_DATA,
  GET_COLOR_DATA,
  GET_ABOUT_PAGE_DATA,
  GET_HISTORY_PAGE_DATA,
  GET_GALLERY_PAGE_DATA,
  GET_RULES_PAGE_DATA,
  GET_CONTACT_PAGE_DATA,
  GET_PARTNERS_PAGE_DATA,
  GET_EVENTS_PAGE_DATA,
  GET_COUNTRY_NAMES,
  GET_ARTICLE_DATA,
  GET_FINALS_PAGE_DATA,
  GET_EVENTS_CSV_LINK,
  GET_GLOBAL_REGISTRATION_PAGE_DATA,
  GET_SCORES_PAGE_DATA,
  GET_DESIGNATED_LEAGUES_PAGE_DATA,
  GET_REGISTRATION_PAGE_DATA
};



// WEBPACK FOOTER //
// ./src/apollo/queries/index.ts